// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------- COMMON LAYOUT ---------------- */
.inp {
  width: 360px;
}

.parent {
  position: relative;
}

.child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fixed {
  position: sticky;
  top: 0;
  z-index: 999;
}

/* ---------------- BREADCRUMB ---------------- */
.breadcrumb {
  display: flex;
  align-items: center;
  margin: 5px 0;
  font-size: 16px;
}
.breadcrumb a {
  text-decoration: none;
  color: #666;
  margin: 0 4px;
}
.breadcrumb .active {
  color: #000;
  font-weight: 500;
}

/* ---------------- SEARCH BAR ---------------- */
.form-control {
  min-width: 300px;
  height: 40px;
}

.form-select {
  height: 40px;
}

/* ---------------- BUTTONS ---------------- */
.btn-add {
  background-color: #0f0f70;
  color: #fff;
  transition: all 0.3s ease-in-out;
}
.btn-add:hover {
  background-color: #0b0b53;
}

/* ---------------- SEARCH ICON (optional future use) ---------------- */
.search-icon {
  margin-left: 10px;
  background-color: #333742;
  padding: 10px 13px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #3B71CA;
  transition: all 0.4s ease-in-out;
}

/* ---------------- TABLE SPACING ---------------- */
.row {
  margin: 0;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-box {
  background: #fff;
  padding: 20px 30px;
  border-radius: 10px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/smart-contract-management/smart-contract-management-search/smart-contract-management-search.component.scss"],"names":[],"mappings":"AAAA,oDAAA;AAEA;EACI,YAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,MAAA;EACA,YAAA;AAAJ;;AAGA,iDAAA;AAEA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AADJ;AAGI;EACI,qBAAA;EACA,WAAA;EACA,aAAA;AADR;AAII;EACI,WAAA;EACA,gBAAA;AAFR;;AAMA,iDAAA;AAEA;EACI,gBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA,8CAAA;AAEA;EACI,yBAAA;EACA,WAAA;EACA,gCAAA;AALJ;AAOI;EACI,yBAAA;AALR;;AASA,wEAAA;AAEA;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAPJ;AASI;EACI,YAAA;EACA,yBAAA;EACA,gCAAA;AAPR;;AAWA,oDAAA;AAEA;EACI,SAAA;AATJ;;AAYA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AATJ;;AAYA;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AATJ","sourcesContent":["/* ---------------- COMMON LAYOUT ---------------- */\n\n.inp {\n    width: 360px;\n}\n\n.parent {\n    position: relative;\n}\n\n.child {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.fixed {\n    position: sticky;\n    top: 0;\n    z-index: 999;\n}\n\n/* ---------------- BREADCRUMB ---------------- */\n\n.breadcrumb {\n    display: flex;\n    align-items: center;\n    margin: 5px 0;\n    font-size: 16px;\n\n    a {\n        text-decoration: none;\n        color: #666;\n        margin: 0 4px;\n    }\n\n    .active {\n        color: #000;\n        font-weight: 500;\n    }\n}\n\n/* ---------------- SEARCH BAR ---------------- */\n\n.form-control {\n    min-width: 300px;\n    height: 40px;\n}\n\n.form-select {\n    height: 40px;\n}\n\n/* ---------------- BUTTONS ---------------- */\n\n.btn-add {\n    background-color: #0f0f70;\n    color: #fff;\n    transition: all 0.3s ease-in-out;\n\n    &:hover {\n        background-color: #0b0b53;\n    }\n}\n\n/* ---------------- SEARCH ICON (optional future use) ---------------- */\n\n.search-icon {\n    margin-left: 10px;\n    background-color: #333742;\n    padding: 10px 13px;\n    color: rgb(210, 207, 207);\n    border-radius: 16%;\n    cursor: pointer;\n\n    &:hover {\n        color: white;\n        background-color: #3B71CA;\n        transition: all 0.4s ease-in-out;\n    }\n}\n\n/* ---------------- TABLE SPACING ---------------- */\n\n.row {\n    margin: 0;\n}\n\n.loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.loader-box {\n    background: #fff;\n    padding: 20px 30px;\n    border-radius: 10px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
